import { AssetVariant } from 'cf-grpc/creativefabrica/content/v1/types_pb'

import {
  getIsProductFree,
  mapCategoryPageTypeToCategoryDetails,
} from '@web/components/content-api/config'
import { ContentAssetVariant } from '@repo/graphql-types'

export function getAssetVariantLabel(assetVariant: AssetVariant, t: (key: string) => string) {
  switch (assetVariant) {
    case AssetVariant.SMALL: {
      return t('variant.s')
    }
    case AssetVariant.MEDIUM: {
      return t('variant.m')
    }
    case AssetVariant.LARGE: {
      return t('variant.l')
    }
    case AssetVariant.XLARGE: {
      return t('variant.xl')
    }
    // oxlint-disable-next-line unicorn/no-useless-switch-case
    case AssetVariant.UNSPECIFIED:
    default: {
      return t('variant.optimized')
    }
  }
}

export interface AssetProp {
  id: string
  filePath: string
  downloadable: boolean
  resolutionWidth: number
  resolutionHeight: number
  variant: AssetVariant
}

export function getAssetsDownloadOptions(categoryId: string, assets: AssetProp[] | undefined) {
  if (!categoryId || !assets) {
    return []
  }

  if (getIsProductFree(categoryId)) {
    const result = assets.filter(asset => asset.filePath.endsWith('.pdf')).slice(0, 1) || []

    if (result.length > 0) {
      return result
    }
  }

  if (
    categoryId === mapCategoryPageTypeToCategoryDetails['quotes'].parentId ||
    categoryId === mapCategoryPageTypeToCategoryDetails['frames'].parentId
  ) {
    const result =
      assets
        .filter(asset => asset.downloadable && asset.filePath.endsWith('.svg'))
        .toSorted((asset1, asset2) =>
          (asset1.resolutionWidth ?? 0) < (asset2.resolutionWidth ?? 0) ? -1 : 1,
        )
        .slice(0, 1) || []

    if (result.length > 0) {
      return result
    }
  }

  const result =
    assets
      .filter(asset => {
        return asset.downloadable && ![AssetVariant.XSMALL].includes(asset.variant)
      })
      .toSorted((asset1, asset2) =>
        (asset1.resolutionWidth ?? 0) < (asset2.resolutionWidth ?? 0) ? -1 : 1,
      ) || []

  return result
}

export function mapContentAssetToAssetVariant(asset: ContentAssetVariant): AssetVariant {
  switch (asset) {
    case ContentAssetVariant.AssetVariantXsmall: {
      return AssetVariant.XSMALL
    }
    case ContentAssetVariant.AssetVariantSmall: {
      return AssetVariant.SMALL
    }
    case ContentAssetVariant.AssetVariantMedium: {
      return AssetVariant.MEDIUM
    }
    case ContentAssetVariant.AssetVariantLarge: {
      return AssetVariant.LARGE
    }
    case ContentAssetVariant.AssetVariantXlarge: {
      return AssetVariant.XLARGE
    }
    // oxlint-disable-next-line unicorn/no-useless-switch-case
    case ContentAssetVariant.AssetVariantUnspecified:
    default: {
      return AssetVariant.UNSPECIFIED
    }
  }
}
